import { useAuthentication } from 'src/features/authentication/context';
import { Protected } from 'src/features/protected-route/components';
import { ACCOUNT_ISSUE_PATH, LOGIN_PATH, PUMP_REPORT_HEADER } from '../../config';
import { AppLayout } from 'src/layouts';
import {
  NAV_ITEMS_HEADER_SITES_MANAGEMENT,
  getNavItemsHeaderSiutesManagementSAAndAA,
} from 'src/features';
import { ReportsPage } from '../../pages';
import { ElementProps } from '../../types/element';
import { LoadingElement } from '../LoadingElement';
import { AccessRoles } from 'src/features/user-account-details/types';
export const PumpReportElement = ({ isSuperAdmin }: ElementProps) => {
  const { isCustomerAccessAllowed, loggedIn, customerId, getCurrentRole, user } =
    useAuthentication();
  const isAccountAdmin = getCurrentRole(customerId.value, null) === AccessRoles.ACCOUNT_ADMIN;
  const getUniqueRedirectPath = () => {
    if (!loggedIn.value) return LOGIN_PATH;
    if (!isSuperAdmin && !isCustomerAccessAllowed.value)
      return ACCOUNT_ISSUE_PATH + '?reason=Access Denied';
  };
  const PumpReportRouteElement = () => (
    <Protected
      isAuthenticated={loggedIn.value}
      isAuthorized={isSuperAdmin || isCustomerAccessAllowed.value}
      uniqueRedirectPath={getUniqueRedirectPath()}
    >
      <AppLayout
        headerTitle={PUMP_REPORT_HEADER}
        headerNavItems={
          isSuperAdmin || isAccountAdmin
            ? getNavItemsHeaderSiutesManagementSAAndAA(user, isSuperAdmin)
            : NAV_ITEMS_HEADER_SITES_MANAGEMENT
        }
      >
        <ReportsPage />
      </AppLayout>
    </Protected>
  );
  const getPumpReportElement = () => {
    if (!loggedIn.loaded) return <LoadingElement />;
    if (loggedIn.loaded && !loggedIn.value) return <PumpReportRouteElement />;
    if (!customerId.value || !customerId.loaded) return <LoadingElement />;
    if (isSuperAdmin && loggedIn.loaded) return <PumpReportRouteElement />;
    if (!isCustomerAccessAllowed.loaded) return <LoadingElement />;
    return <PumpReportRouteElement />;
  };
  return getPumpReportElement();
};
